// extracted by mini-css-extract-plugin
export default {"nutritionInfo":"FoodServingView_nutritionInfo__bpueZ","nutritionValue":"FoodServingView_nutritionValue__+utOY"};